import { FaBars, FaTimes } from "react-icons/fa";
import { IoCodeSlash } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useState } from "react";
import "../Stylesheet/Navbar.css";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    const { lang, setLang, t } = useContext(LanguageContext);
    const n = t.navbar;

    const navigate = useNavigate();

    return (
        <div className="Navbar">
            <div className="Nav-head">
                <div className="Nav-icon"><IoCodeSlash onClick={() => {
                    navigate("/");
                }} /></div>
                <div>
                    <h3>{n.brand}</h3>
                </div>
            </div>

            {/* Hamburger Icon */}
            <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? <FaTimes /> : <FaBars />}
            </div>

            {/* Navigation */}
            <div className={`Nav-List ${menuOpen ? "active" : ""}`}>
                <ul>
                    <li><Link to="/" onClick={() => setMenuOpen(false)}>{n.home}</Link></li>
                    <li><Link to="/about" onClick={() => setMenuOpen(false)}>{n.about}</Link></li>
                    <li><Link to="/contact" onClick={() => setMenuOpen(false)}>{n.contact}</Link></li>
                </ul>

                {/*Language Select */}
                <select
                    className="lang-select dark"
                    value={lang}
                    onChange={(e) => setLang(e.target.value)}>

                    <option value="en">English</option>
                    <option value="ta">தமிழ்</option>
                </select>

            </div>

        </div>
    );
}
